import { graphql } from "../generated";

export const DeleteNote = graphql(`
  mutation DeleteNote($noteId: ID!) {
    deleteNote(noteId: $noteId) {
      id
    }
  }
`);
